import restCrudReducer from '../../../np-crud/store/restCrudReducer';

const [crudInitialState, crudReducer] = restCrudReducer({
    pluginName: 'CUSTOMER_ERASURE_METHOD',
    entityName: 'CUSTOMER_ERASURE_METHOD',
});

const initialState = {
    ...crudInitialState,
    saving: false
};
const reducer = (state = initialState, action) => {
    const newState = crudReducer(state, action);
    if (newState !== null) {
        return newState;
    }
    switch (action.type) {
        case 'CORE|LOGOUT_SUCCESS':
        case 'CORE|CORE_SET_ACTIVE_CUSTOMER_SUCCESS':
            return initialState;
        default:
            return state;
    }
};
export default reducer;